import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-outgoing-job-status',
  templateUrl: './outgoing-job-status.component.html',
  styleUrls: ['./outgoing-job-status.component.scss']
})
export class OutgoingJobStatusComponent implements OnInit {
  @Input() outgoingJob: any = {};

  constructor() { }

  ngOnInit(): void {
  }

}
